import axios from "axios";
import store from "../redux/store/store";
import { refreshAccessToken } from "../redux/actions/authActions";

// Create an axios instance with baseURL

/*const instance = axios.create({
  baseURL: "http://localhost:5081",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  withCredentials: true, // Ensure cookies are sent with all requests
}); */

// const protocol = window.location.protocol === "https:" ? "https" : "https";
// const baseURL = `${protocol}://lccapi.mwetanacloud.com`;
// const baseURL = "https://lccapi.cubetrix.tech";
const baseURL = "https://lccapi.mwetanacloud.com";

const instance = axios.create({
  baseURL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

let isRefreshing = false; // Flag to indicate if a refresh request is in progress
let refreshSubscribers = []; // Queue for requests waiting for a new token

// Notify all subscribers with the new token
const onTokenRefreshed = (newAccessToken) => {
  refreshSubscribers.forEach((callback) => callback(newAccessToken));
  refreshSubscribers = [];
};

// Add a subscriber to the queue
const addSubscriber = (callback) => {
  refreshSubscribers.push(callback);
};

// Request Interceptor: Attach accessToken to headers
instance.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    // If the data is FormData, delete Content-Type to let browser set it with boundary
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }

    return config;
  },
  (error) => Promise.reject(error),
);

// Response Interceptor: Handle token expiration and refresh
instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If 401 error and not already retried, try refreshing the token
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true; // Mark request as retried

      if (!isRefreshing) {
        isRefreshing = true;

        try {
          // Refresh the token
          const response = await store.dispatch(refreshAccessToken());
          const newAccessToken = response.payload; // Get the accessToken from the response payload and set it in newAccessToken const

          // Save the new token and notify all queued requests
          if (newAccessToken) {
            localStorage.setItem("accessToken", newAccessToken);
            onTokenRefreshed(newAccessToken);
          }

          isRefreshing = false;
        } catch (refreshError) {
          isRefreshing = false;
          refreshSubscribers = []; // Clear queued requests

          // If refresh fails, log out the user or redirect to login
          localStorage.removeItem("accessToken");
          window.location.href = "/login"; // Route the user to the login route
          return Promise.reject(refreshError);
        }
      }

      // Queue the request until the token is refreshed
      return new Promise((resolve) => {
        addSubscriber((newAccessToken) => {
          originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
          resolve(instance(originalRequest));
        });
      });
    }

    return Promise.reject(error); // Reject other errors
  },
);

export default instance;
